import { useEffect, useState } from 'react'
import { io, Socket } from 'socket.io-client'
import useAuth from './useAuth'
import { API_BASE_URL } from '../config/credentials'

export default function useSocketProvider() {
    const { session } = useAuth()
    const [socket, setSocket] = useState<Socket<any, any> | null>(null)

    useEffect(() => {
        const _socket = io(API_BASE_URL, {
            reconnectionDelayMax: 10000,
            auth: {
                token: session?.token
            },
            transports: ['websocket']
        })
        setSocket(_socket)
        return () => {
            _socket.disconnect()
        }
    }, [])

    return socket
}
